import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DialogService } from 'src/services/dialog/dialog.service';

@Component({
  selector: 'pro-badge',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './pro-badge.component.html',
  styleUrl: './pro-badge.component.scss',
})
export class ProBadgeComponent {
  @Input() size = 20;
  @Input() tooltip: string | null = 'Available with Prefund Pro';
  @Input() color = 'gray-500';
  @Input() disableDialog = false;

  constructor(public dialogService: DialogService) {}
}
